<template>
    <div class="nav-bottom">
        <a href="https://tb.53kf.com/code/client/10055204/1" class="advice">在线咨询</a>
        <a href="tel:4008635888" class="advice">电话沟通</a>
    </div>
</template>
<script>
    export default{
        data(){
            return{}
        },
    }
</script>


// WEBPACK FOOTER //
// src/components/bottom.vue